<app-slider></app-slider>
<app-bienvenido></app-bienvenido>